module.exports = __webpack_public_path__ + "img/drug.6957136b.svg";